'use client'
import { type Dispatch, type FC, type SetStateAction } from 'react'
import { MODALS } from '@/context'
import { useModal } from '@/hooks'
import { css } from 'styled-components'
import { mq, vw } from '@/styles'
import type { TypeCmsProductsByCategoryList } from '@/schema'
import { useTranslator } from '@/hooks'
import { FormFilters } from '../forms/FormFilters'
import { Modal } from './Modal'

type Props = {
  data: TypeCmsProductsByCategoryList['filters']
  forceResetFilters: boolean
  setForceResetFilters: Dispatch<SetStateAction<boolean>>
  fieldGroupToReset: string | null
  setFieldGroupToReset: Dispatch<SetStateAction<string | null>>
	activeTypologiesHasMoreThanOneInstallation?: boolean
}

export const ModalFilters: FC<Props> = ({ data, forceResetFilters, setForceResetFilters, fieldGroupToReset, setFieldGroupToReset }) => {
  const { isActive, updatePayload } = useModal(MODALS.FILTERS)
	const { t } = useTranslator()
	const close = () => {
		updatePayload({ close: true })
	}

  return (<>
    <Modal isActive={isActive} close={close} title={t('project.filters.more_filters') as string} xAlign='center' zIndex={8000} dialogStyles={dialogStyles} hasToClose={true}>
			<FormFilters data={data} submitOnChange={true} forceResetFilters={forceResetFilters} setForceResetFilters={setForceResetFilters} fieldGroupToReset={fieldGroupToReset} setFieldGroupToReset={setFieldGroupToReset} />
    </Modal>
    <button className='btn--backdrop' aria-label='close' {...!isActive && { disabled: true }} onClick={close}></button>
  </>
  )
}

const dialogStyles = css`
	background-color: white;
  margin: 0;
	max-width: 1000px !important;

	${mq.greaterThan('tablet')} {
		margin: 5vh 2vw;
	}

	${mq.greaterThan('desktop')} {
		margin: 5vh 2vw;
	}

	header {
		padding-right: 8px;

		${mq.greaterThan('tablet')} {
			padding-right: 16px;
		}
	}

	.modal__body {
    padding-bottom: ${vw(40 - 4.25, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      padding-bottom: ${vw(40 - 4.25, 'nexus7')};
    }

    ${mq.greaterThan('tablet')} {
			max-height: calc(90vh - 65px);
			overflow-y: auto;
      padding-bottom: ${vw(40 - 12.5, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      padding-bottom: 27.5px 75px;
    }
  }
`